import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from "vue";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
import { getAppRoot } from "@/onload/loadConfig";
import HelpPopover from "@/components/Help/HelpPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormElementHelpMarkdown',
    props: {
        content: null
    },
    setup(__props) {
        const props = __props;
        const markdownHtml = computed(() => markup(props.content ?? "", false));
        const helpHtml = ref();
        const internalHelpReferences = ref([]);
        function setupPopovers() {
            internalHelpReferences.value.length = 0;
            if (helpHtml.value) {
                const links = helpHtml.value.getElementsByTagName("a");
                Array.from(links).forEach((link) => {
                    if (link.href.startsWith("gxhelp://")) {
                        const uri = link.href.substr("gxhelp://".length);
                        internalHelpReferences.value.push({ element: link, term: uri });
                        link.href = `${getAppRoot()}help/terms/${uri}`;
                        link.style.color = "inherit";
                        link.style.textDecorationLine = "underline";
                        link.style.textDecorationStyle = "dashed";
                    }
                });
            }
        }
        onMounted(setupPopovers);
        return { __sfc: true, props, markdownHtml, helpHtml, internalHelpReferences, setupPopovers, HelpPopover };
    }
});
